import { useQuery } from '@tanstack/react-query'
import { GETMarketplaceItemDetail } from '../requests'

export const GET_ITEM_DETAIL_QUERY_KEY = (
  itemId: number,
  thirdPartyItemId?: number
) =>
  thirdPartyItemId
    ? ['itemDetail', itemId, thirdPartyItemId]
    : ['itemDetail', itemId]

export const useMarketplaceItemDetail = (
  itemId: number,
  thirdPartyItemId?: number
) => {
  return useQuery({
    queryKey: GET_ITEM_DETAIL_QUERY_KEY(itemId, thirdPartyItemId),
    queryFn: () => GETMarketplaceItemDetail(itemId, thirdPartyItemId),
    enabled: !!itemId,
  })
}
